import cx from 'classnames';
import * as animationStyles from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/Animations.module.scss';
import {SubcategorySection} from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/components/SubcategorySection/SubcategorySection';
import type {AnimationDirection} from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/HamburgerMenuDrawer';
import type {InvitationCategoryType} from '~/common/components/MegaNav/MegaNavVariant/types';
import * as styles from './SubcategoryLevelView.module.scss';

type SubcategoryLevelViewProps = {
  category: InvitationCategoryType | null;
  animationDirection: AnimationDirection;
  onAnimationEnd: () => void;
  closeNav: () => void;
};

export const SubcategoryLevelView = ({
  category,
  animationDirection,
  onAnimationEnd,
  closeNav,
}: SubcategoryLevelViewProps) => {
  if (!category) return null;

  const getAnimationClass = () => {
    switch (animationDirection) {
      case 'slide-left':
        return animationStyles.slideLeftIn;
      case 'slide-right':
        return animationStyles.slideRightOut;
      default:
        return animationStyles.noAnimation;
    }
  };

  return (
    <div
      className={cx(animationStyles.drawerContainer, getAnimationClass())}
      onAnimationEnd={onAnimationEnd}
    >
      <div className={styles.content}>
        {category.subCategories.map((subCategory) => (
          <SubcategorySection
            key={subCategory.display_name}
            subCategory={subCategory}
            closeNav={closeNav}
          />
        ))}
      </div>
    </div>
  );
};
